<template>
	<div>
		<template v-if="customer">
			<div>
				{{ customer.fullName }}
				<span v-if="customer.role">({{ customer.role }})</span>
			</div>
			<div v-if="!customer.dataComplete" class="mt-3 text-right">
				<Button text="Meine Daten vervollständigen" icon="edit" @click="showPopUp = true"/>
			</div>
			<div v-else class="mt-3">
				<div class="mt-4">
					<div class="font-weight-bold">Firmendaten</div>
					<div>{{ customer.companyName }}</div>
					<div>
						{{ customer.street }} {{ customer.streetNumber }},
						{{ customer.zip }} {{ customer.city }},
						{{ customer.country.text }}
					</div>
					<div v-if="customer.companyNumber">{{ customer.companyNumber }}</div>
					<div v-if="customer.vatNumber">{{ customer.vatNumber }}</div>
					<div v-if="customer.website">{{ customer.website }}</div>
				</div>
				<div v-if="customer.externalCompanyName" class="mt-4">
					<div class="font-weight-bold">Auftraggeber-Daten</div>
					<div>{{ customer.externalCompanyName }}</div>
					<div v-if="customer.externalCompanyNumber">{{ customer.externalCompanyNumber }}</div>
				</div>
				<div class="mt-2 text-right">
					<Button text="Daten bearbeiten" icon="edit" @click="showPopUp = true"/>
				</div>
			</div>
		</template>
		<PopUp
			v-if="showPopUp"
			title="Meine Daten"
			size="xl"
			hide-actions
			@hidden="showPopUp = false"
		>
			<CompleteData
				v-if="customer"
				:with-personal-data="true"
				:customer="customer"
				:data-complete="customer.dataComplete"
				@complete="onComplete"
			/>
		</PopUp>
	</div>
</template>
<script>
import FormGroup from "@/vue/common/form/Group.vue";
import Button from "@/vue/common/Button.vue";
import CompleteData from "@/vue/customer/CompleteData.vue";
import {mapState} from "vuex";
import * as Toast from "@/helper/layout/Toast";
import PopUp from "@/vue/common/PopUp.vue";

export default {

	components: {
		PopUp,
		CompleteData,
		Button,
		FormGroup
	},

	data ()
	{
		return {
			showPopUp: false,
		};
	},

	computed: {
		...mapState('auth', ['customer'])
	},

	methods: {
		onComplete ()
		{
			this.showPopUp = false;

			Toast.success(this, ['Daten erfolgreich geändert']);

			this.$emit('change');
		}
	}
}
</script>
